import { EditorialFrame } from '../EditorialFrame';
import { IContactUserDataProps } from './contactUserData.models';
import * as S from './contactUserData.style';

export const ContactUserData = ({
  emailTitle,
  email,
  phoneNumberTitle,
  phoneNumber,
  title,
  ...rest
}: IContactUserDataProps) => {
  return (
    <EditorialFrame title={title} {...rest}>
      <S.Wrapper>
        <section>
          <S.Title>{phoneNumberTitle}</S.Title>
          <S.Data>{phoneNumber}</S.Data>
        </section>
        <section>
          <S.Title>{emailTitle}</S.Title>
          <S.Data>{email}</S.Data>
        </section>
      </S.Wrapper>
    </EditorialFrame>
  );
};

